import * as R from 'ramda'

export const calculateProgress = participant => {
  const percent =
    (participant.runs
      .map(each => each.status === 'approve' && each.distance)
      .reduce((prev, next) => prev + next, 0) *
      100) /
    R.path(['race_detail', 'distance', 'value'], participant)

  return percent >= 100 ? 100 : Number.isNaN(percent) ? 0 : percent.toFixed(2)
}



// WEBPACK FOOTER //
// /opt/build/repo/src/components/ParticipantCard/utils.js